import React, { useState } from "react";
import { Text, View } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate } from "react-router-dom";
import { InputField } from "../../components/InputField";
import { Header } from "../../components/Header";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import useUniqueDispatch, {
  isData,
  isLoading,
  useSelector,
} from "../../utils/redux-utils";
import {
  userLogoutAction,
  userSendConfirmEmailAction,
} from "../../store/user/action";
import { RootState } from "../../store/root-reducer";

export const SendEmailPage = () => {
  const [logoutToken, logout] = useUniqueDispatch(userLogoutAction.request);

  const [sendEmailToken, sendEmail] = useUniqueDispatch(
    userSendConfirmEmailAction.request
  );

  const userRequest = useSelector((store: RootState) => store.user);

  const isSending = isLoading(userRequest, sendEmailToken);
  const isSent = isData(userRequest, sendEmailToken);

  return (
    <CommonScreenCard>
      <Header onPressLeft={() => logout([{}])} />
      <View style={{ flex: 1, alignItems: "center" }}>
        <Text
          style={[
            fonts.title,
            { marginBottom: 8, textAlign: "center", maxWidth: 340 },
          ]}
        >
          Please confirm your email.
        </Text>
        <Text style={[fonts.mediumText_regular, { marginBottom: 51 }]}>
          We will send you email with confirm link
        </Text>
      </View>

      {isSent ? (
        <Text style={[fonts.mediumText_regular, { marginBottom: 51 }]}>
          Confirm email has been sent to you
        </Text>
      ) : (
        <CommonButton
          textStyle={fonts.mediumText_bold}
          style={{ marginBottom: 100 }}
          isLoading={isSending}
          title="Send confirm email"
          type={"blackFilled"}
          onPress={() => sendEmail([{}])}
        />
      )}
    </CommonScreenCard>
  );
};
